import React from 'react';
import { Flag } from '@mui/icons-material';

const PriorityFlag = ({ color, name }) => {
  const priorityColorMap = {
    low: '#28a745',
    medium: '#ffc107',
    high: '#fd7e14',
    critical: '#dc3545',
  };

  const finalColor = color || priorityColorMap[name?.toLowerCase()] || '#6c757d';

  return (
    <span
      className="btn-transparent"
      title={name}
      style={{
        display: 'flex',
        alignItems: 'center',
        cursor: 'default',
        padding: '10px',
      }}>
      <Flag sx={{ color: finalColor }} />
    </span>
  );
};

export default PriorityFlag;